import React from 'react';
import DateTime from '_class/DateTime';
import { getRootUrl } from 'helpers/url';
import { Link } from 'react-router-dom';
import { Icon } from '@haldor/ui';
import { useTranslate } from 'lib/translate';

var DisplayCell = function DisplayCell(_ref) {
  var cell = _ref.cell,
      color = _ref.color,
      assessmentDetails = _ref.assessmentDetails,
      isSelected = _ref.isSelected;
  var translate = useTranslate();
  /**
   * @param {object} detail
   */

  var getDetailLink = function getDetailLink(detail) {
    if (detail.assessment.referenceType == 'Plan') {
      return getRootUrl() + "plan/".concat(detail.navigationObject.referenceId);
    }

    if (detail.assessment.referenceType == 'AssignmentTask') {
      return getRootUrl() + "assignment/".concat(detail.navigationObject.referenceId);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cell-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: isSelected ? "cell selected" : "cell",
    style: {
      '--level-color': color
    }
  }, cell.text != null ? cell.text : cell.value), assessmentDetails.map(function (detail) {
    return /*#__PURE__*/React.createElement(Link, {
      to: getDetailLink(detail),
      key: detail.id,
      className: "assessment-detail"
    }, /*#__PURE__*/React.createElement("div", {
      className: "cell selected",
      style: {
        '--level-color': color
      }
    }, detail.assessment.referenceType == 'Plan' ? translate('Plan') : translate('Assignment'), /*#__PURE__*/React.createElement("div", {
      className: "size-12"
    }, detail.navigationObject.title), /*#__PURE__*/React.createElement("div", {
      className: "size-12",
      style: {
        marginTop: '.25rem'
      }
    }, detail.editorUser != null ? detail.editorUser.firstName + ' ' + detail.editorUser.lastName : null, ' • ' + new DateTime(detail.assessment.published).getLongDate()), /*#__PURE__*/React.createElement(Icon, {
      name: "Check"
    })));
  }));
};

DisplayCell.defaultProps = {
  isSelected: false,
  color: '#ccc',
  assessmentDetails: []
};
export default DisplayCell;